// 页面路径映射
export const PAGE_PATH_MAP = {
  // 原生页面
  // 我的钱包页面
  myWallet: 'page:my_wallet',

  // 收益明细
  incomeList: '/income/list/all',
  // 新人指南
  guideNewUser: '/guide/newuser',
  // 我的权益页面
  myRights: '/rights',
  // 绑定设备活动规则
  bindDeviceRule: '/acts/rules/bindDevice',
  //   加机活动规则
  addDeviceRule: '/acts/rules/addDevice',
  // 被邀请人活动规则
  inviteeRule: '/invite/rule/invitee',
  // 邀请用户任务页
  inviteeAct: '/acts/invitee',
  // 非邀请用户任务页
  uninvitedAct: '/acts/uninvited',
  //  云豆抽奖规则
  yundouLotteryRule: '/acts/rules/yundouLottery',
  // 第三方页面
  // 有赞新客专享
  youzanNewUser: 'youzan:https%3A%2F%2Fj.youzan.com%2F90XJ2T',
  
};
